import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import { Link } from 'react-router-dom';
import "./RowComponent.css"
const RowComponent = ({ title, links }) => {


    const titleStyle = {
        color: 'black', // Elegant blue for better readability
        fontFamily: "'FiraGO-SemiBold'",
        fontSize: '20px', // Slightly larger font size for emphasis
        fontWeight: 600, // Semi-bold for better prominence
        lineHeight: '1.4', // Maintain spacing between lines
        marginBottom: '10px', // Slightly more spacing below for clarity
        textTransform: 'uppercase', // Capitalized text for emphasis
    };



    return (
        <div className={"row-style-info"}>
            <span style={titleStyle}>{title}</span>
            {links.map((link, index) => (
                <div key={index} className="row-link">
                    <Link to={link.to || '#'} >
                        {link.text}
                    </Link>
                </div>
            ))}
        </div>
    );
};

const InfoComponent = ({rowsData}) => {




    return (
        <div className={"info-comp-container"}>
            {rowsData.map((rowData, index) => (
                <RowComponent key={index} title={rowData.title} links={rowData.links} />
            ))}
        </div>
    );
};

export default InfoComponent;
